
import { EmployeeFreebieModel, EmployeeFreebiesResponse, FreebieIdRequest, FreebiesResponse } from '@gtpl/shared-models/canteen-management';
import { ErrorResponse, GlobalVariableValues, MessageParameters } from '@gtpl/shared-models/common-models';
import { AllEmployeesResponseModel, CommonResponse } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { getManager, In } from 'typeorm';
import { FreebiesServices } from '../freebies/freebies.service';
import { EmployeeCodesRequest } from './dto/employee-codes.request';
import { EmployeeFreebiesAssignRequest } from './dto/employee-freebies-assign.request';
import { EmployeeTokenConsumptionReportRequest } from './dto/employee-token-cons-report.request';
import { EmployeeFreebiesRepo } from './repository/employee-freebies.repository';
import { FreebiesConsumptionRepo } from './repository/freebies-consumption.repository';
import { TokenConsumptionReportQueryResponse } from './repository/query-response/token-cons-report.query.response';
import { TokensHelperService } from './tokens-helper.service';
import { TokensAdapter } from './tokens.adapter';
import whatsApp from "apps/services/whatsapp";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { EmployeeFreebiesEntity } from './entity/employee-freebies.entity';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';

@Injectable()
export class TokensService {
    constructor(
        private employeeFreebieRepo: EmployeeFreebiesRepo,
        private freebieConsumptionRepo: FreebiesConsumptionRepo,
        private tokenHelperService: TokensHelperService,
        private freebieService: FreebiesServices,
        private tokensAdapter: TokensAdapter,
        private wpService: WhatsAppNotificationService,
        private wtsAppBroadCatService: WhatsappBroadCastService,

    ) {

    }

    async createToken(employeeFreebiesAssignRes: EmployeeFreebiesAssignRequest): Promise<CommonResponse> {
        try {
            console.log(employeeFreebiesAssignRes)
            employeeFreebiesAssignRes.employeeFreebiesId = null;
            // check if the freebie already exist 
            const freebie = await this.getFreebieByCodeHelper(employeeFreebiesAssignRes.employeeFreebiesId);
            if (freebie) {
                throw new ErrorResponse(0, 'Freebie Code Already Exists');
            }
            // save the freebies request into the DB
            const tokenEntity = this.tokensAdapter.convertEmpFreebieDtoToEntity(employeeFreebiesAssignRes);
            const savedTokens = await this.employeeFreebieRepo.save(tokenEntity);
            const tokensModel = this.tokensAdapter.convertEmpFreebieEntityToDto(savedTokens);
            return new CommonResponse(true, 0, 'Freebies saved successfully', [tokensModel]);
        } catch (err) {
            throw err;
        }
    }


    /**
     * maps the employees freebies
     * @returns 
     */
    async createEmployeeFreebies(employeeFreebiesAssignRes: EmployeeFreebiesAssignRequest[]): Promise<EmployeeFreebiesResponse> {
        const transactionManager = new GenericTransactionManager();
        try {
            const employeeFreebies = [];
            for (const freebieAssignReq of employeeFreebiesAssignRes) {
                freebieAssignReq.employeeFreebiesId = null;
                // check if the employee code is valid
                const empInfo: AllEmployeesResponseModel = null// await this.checkIfEmployeeCodeValid(freebieAssignReq.employeeCode);
                // check if the freebieId is valid
                const freebieInfo = await this.tokenHelperService.getFreebieRecordByFreebieId(freebieAssignReq.freebieId);
                // check if for a given month the employee is already mapped
                const hasFreebie = await this.tokenHelperService.getEmployeeFreebieForEmpIdFreebieIdAndMonth(freebieAssignReq.employeeCode, freebieAssignReq.freebieCode, freebieAssignReq.month);
                if (hasFreebie) {
                    throw new ErrorResponse(0, 'This Freebie has already been allocated for the current employee for the current month');
                }
                //freebieAssignReq.employeeId = empInfo.employeeId;
                const empFreebieEnt = await this.tokensAdapter.convertEmpFreebieDtoToEntity(freebieAssignReq);
                // save all the freebies assignment
                console.log(empFreebieEnt)
                await transactionManager.startTransaction();
                const savedEmpFreebieMap = await transactionManager.getCustomRepository(EmployeeFreebiesRepo).save(empFreebieEnt);
                employeeFreebies.push(this.tokensAdapter.convertEmpFreebieEntityToDto(savedEmpFreebieMap));
            }
            await transactionManager.completeTransaction();
            // save the array of objects into the db
            return new EmployeeFreebiesResponse(true, 0, 'Freebies saved for the employees successfully', employeeFreebies);

        } catch (error) {
            throw error;
        } finally {
            await transactionManager.releaseTransaction();
        }
    }

    async getFreebieByIdHelper(employeeFreebieId: number): Promise<EmployeeFreebiesEntity> {
        return await this.employeeFreebieRepo.findOne({ where: { employeeFreebieId: employeeFreebieId } });
    }

    async getFreebieByCodeHelper(employeeFreebiesId: number): Promise<EmployeeFreebiesEntity> {
        return await this.employeeFreebieRepo.findOne({ where: { employeeFreebiesId: employeeFreebiesId } });
    }



    /**
     * maps the employees freebies
     * @returns 
     */
    async updateEmployeeFreebies(employeeFreebiesAssignRes: EmployeeFreebiesAssignRequest): Promise<EmployeeFreebiesResponse> {
        console.log(employeeFreebiesAssignRes,'----------------------------------------')
        const transactionManager = new GenericTransactionManager();
        try {
            const employeeFreebies = [];
                const empFreebieInfo = await this.tokenHelperService.getEmployeeFreebieRecordById(employeeFreebiesAssignRes.employeeFreebiesId);

                if (!empFreebieInfo) {
                    throw new ErrorResponse(0, 'Data does not exist to update. Pleas verify');
                }
                const empInfo: AllEmployeesResponseModel = null
                // await this.checkIfEmployeeCodeValid(freebieAssignReq.employeeCode);
                // check if the freebieId is valid
                // const freebieInfo = await this.tokenHelperService.getFreebieRecordByFreebieId(employeeFreebiesAssignRes.freebieId);

                // check if for a given month the employee is already mapped
                const hasFreebie = await this.tokenHelperService.getEmployeeFreebieForEmpIdFreebieIdAndMonth(employeeFreebiesAssignRes.employeeCode, employeeFreebiesAssignRes.freebieCode, employeeFreebiesAssignRes.month);

                if (hasFreebie) {
                    if (hasFreebie.employeeFreebiesId !== employeeFreebiesAssignRes.employeeFreebiesId) {
                        // throw new ErrorResponse(0, 'You cannot modify the freebie type mapped to an employee.');
                        throw new ErrorResponse(0, 'This Freebie has already been allocated for the current employee for the current month');
                    }
                }
                //employeeFreebiesAssignRes.employeeId = empInfo.employeeId;
                const empFreebieEnt = await this.tokensAdapter.convertEmpFreebieDtoToEntity(employeeFreebiesAssignRes);
                // save all the freebies assignment
                await transactionManager.startTransaction();
                // const savedEmpFreebieMap = await transactionManager.getCustomRepository(EmployeeFreebiesRepo).save(empFreebieEnt);
                const savedEmpFreebieMap = await this.employeeFreebieRepo.save(empFreebieEnt)
                employeeFreebies.push(this.tokensAdapter.convertEmpFreebieEntityToDto(savedEmpFreebieMap));
            
            await transactionManager.completeTransaction();
            return new EmployeeFreebiesResponse(true, 0, 'Freebies saved for the employees successfully', employeeFreebies);
        } catch (error) {
            throw error;
        } finally {
            await transactionManager.releaseTransaction();
        }
    }

    /**
     * gets the employee freebies for the given employee code
     * @param employeeCodeReq 
     */
    async getEmployeeFreebies(employeeCodeReq: EmployeeCodesRequest): Promise<EmployeeFreebiesResponse> {
        const freebies = await this.tokenHelperService.getEmployeeFreebieRecordByEmpCodes(employeeCodeReq.employeeCodes);
        if (freebies.length == 0) {
            throw new ErrorResponse(0, 'No freebies mapped to the employee');
        }
        const empFreebieModels: EmployeeFreebieModel[] = [];
        for (const empFreebie of freebies) {
            empFreebieModels.push(this.tokensAdapter.convertEmpFreebieEntityToDto(empFreebie));
        }
        return new EmployeeFreebiesResponse(true, 0, 'Freebies saved for the employees successfully', empFreebieModels);
    }

    // async getAllEmployeeFreebies(): Promise<EmployeeFreebiesResponse> {
    //     const freebies = await this.employeeFreebieRepo.find({ isActive: true });
    //     if (freebies.length === 0) {
    //         throw new ErrorResponse(0, 'No freebies were found');
    //     } else {
    //         const empFreebieModels: EmployeeFreebieModel[] = [];
    //         for (const empFreebie of freebies) {
    //             empFreebieModels.push(this.tokensAdapter.convertEmpFreebieEntityToDto(empFreebie));
    //         }
    //         return new EmployeeFreebiesResponse(true, 0, 'Freebies for the employees fetched successfully', empFreebieModels);
    //     }
    // }

    async getemployeeFreebieById(employeeFreebieId: number): Promise<EmployeeFreebiesEntity> {
        const freebie = await this.employeeFreebieRepo.findOne({ where: { employeeFreebiesId: employeeFreebieId } });
        console.log(freebie,'******')
        if (freebie) {
            return freebie;
            } else {
            return null;
            }
    }


    /**
     * deletes the employee freebies
     * @param employeeCodeReq 
     */
    async deleteEmployeeFreebies(employeeCodeReq: EmployeeCodesRequest): Promise<EmployeeFreebiesResponse> {
        const transactionManager = new GenericTransactionManager();
        try {
            const freebies = await this.tokenHelperService.getEmployeeFreebieRecordByEmpCodes(employeeCodeReq.employeeCodes);
            if (freebies.length == 0) {
                throw new ErrorResponse(0, 'No freebies mapped to the employee');
            }
            for (const freebie of freebies) {
                await transactionManager.startTransaction();
                await transactionManager.getCustomRepository(EmployeeFreebiesRepo).update({ employeeFreebiesId: freebie.employeeFreebiesId }, { isActive: false, updatedUser: employeeCodeReq.username });
            }
            await transactionManager.completeTransaction();
            return new EmployeeFreebiesResponse(true, 0, 'Freebies delete for the employee successfully', []);
        } catch (error) {
            throw error;
        } finally {
            await transactionManager.releaseTransaction();
        }
    }

    async checkEmployeewithfrbId(freebieId: FreebieIdRequest): Promise<boolean> {
        const b = await this.employeeFreebieRepo.findOne({ where: { freebieId: freebieId.freebieId, isActive: true } });
        return b ? true : false;
    }

    async sendDailyTokenConsumptionStatus(): Promise<CommonResponse> {
        try {
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-' + currDate.getDate();
            const monthStartDate = currDate.getFullYear() + '-' + (Number(currDate.getMonth()) + 1) + '-01';
            const currTime = currDate.getHours() + ':' + currDate.getMinutes();
            const manager = getManager();
            const query = `SELECT SUM(IF(freebie_category = 'DINNER MEAL', 1,0)) AS dinnerMealCount , SUM(IF(freebie_category = 'LUNCH MEAL', 1,0)) AS lunchMealCount, SUM(IF(freebie_category = 'BREAKFAST', 1,0)) AS brkfastCount, SUM(IF(freebie_category = 'SNACKS', 1,0)) AS snacksCount FROM ` + appSettings.cms_db + `.freebies_consumption WHERE DATE(created_at) = DATE(NOW()) `
            const currData = await manager.query(query)

            const MtdQuery = `SELECT SUM(IF(freebie_category = 'DINNER MEAL', 1,0)) AS mtdDinnerMealCount , SUM(IF(freebie_category = 'LUNCH MEAL', 1,0)) AS mtdLunchMealCount, SUM(IF(freebie_category = 'BREAKFAST', 1,0)) AS mtdBrkfastCount, SUM(IF(freebie_category = 'SNACKS', 1,0)) AS mtdSnacksCount FROM ` + appSettings.cms_db + `.freebies_consumption WHERE DATE(created_at) BETWEEN ` + monthStartDate + ` AND DATE(NOW())` ;
            const mtdData = await manager.query(MtdQuery)
            const parameters = [
                { "type": "text", "text": date },
                { "type": "text", "text": Number(currData[0]?.brkfastCount) +'('+Number(mtdData[0]?.mtdBrkfastCount)+')' },
                { "type": "text", "text": Number(currData[0]?.lunchMealCount) +'('+Number(mtdData[0]?.mtdLunchMealCount)+')'},
                { "type": "text", "text": Number(currData[0]?.snacksCount) +'('+Number(mtdData[0]?.mtdSnacksCount)+')'},
                { "type": "text", "text": Number(currData[0]?.dinnerMealCount) +'('+Number(mtdData[0]?.mtdDinnerMealCount)+')'},
            ];
            const contacts = whatsApp.contacts
            let statusFlag = true
            console.log('-----parameter data-----',parameters)
            for (const contact of contacts) {
                const req = new MessageParameters(contact, 'canteen_management_usage', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus)
                if (!messageStatus.status) {
                    statusFlag = false
                }else{
                    const whatsapplogDto = new WhatsAppLogDto(contact,'canteen_management_usage','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.canteenmanagementmoduleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }
            if (statusFlag) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully")
            }
        } catch (error) {
            console.log(error, 'error--')
            throw error;
        }
    }

    async ActivateorDeactivateToken(freebiesReq: EmployeeCodesRequest): Promise<FreebiesResponse> {
        try {
            console.log('^^^^^^^^^^^^',freebiesReq)
            const tokenExists = await this.getemployeeFreebieById(freebiesReq.employeeFreebiesId);
            console.log(tokenExists.isActive+'tokenExists')
            if (tokenExists) {
                if (freebiesReq.versionFlag !== tokenExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Token information.Refresh and try again');
                } else {
                    const tokenStatus = await this.employeeFreebieRepo.update(
                        { employeeFreebiesId: freebiesReq.employeeFreebiesId },
                        { isActive: freebiesReq.isActive, updatedUser: freebiesReq.updatedUser });
                        
                    if (tokenExists.isActive) {
                        if (tokenStatus.affected) {
                            const tokenResponse: FreebiesResponse = new FreebiesResponse(true, 10115, 'Token is de-activated successfully');
                            return tokenResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Token is already deactivated');
                        }
                    } else {
                        if (tokenStatus.affected) {
                            const departmentResponse: FreebiesResponse = new FreebiesResponse(true, 10114, 'Token is activated successfully');
                            return departmentResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Token is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAllEmployeeFreebies():Promise<CommonResponse>{
          const manager = getManager();
          const query = `SELECT employee_code AS employeeCode , employee_id AS employeeId , employee_freebies_id AS employeeFreebiesId , ef.freebie_code AS freebieCode ,
          year AS year , month AS month , original_count AS totalTokens , available_count AS availableTokens , max_consumption_per_day AS maxConsumptionPerDay,
          ef.is_active AS isActive ,ef.freebie_id AS freebieId FROM ` +appSettings.cms_db + `.employee_freebies ef LEFT JOIN `+appSettings.cms_db + `.freebie f ON f.freebie_id = ef.freebie_code WHERE ef.is_active = 1`
          const data = await manager.query(query)
          if(data.length > 0){
            return new CommonResponse(true, 0, 'Freebies for the employees fetched successfully', data);
          }else{
            throw new ErrorResponse(0, 'No freebies were found');
          }
    }

}
